import { Entity } from "src/app/shared/types/entity.type";
import { Asset, AssetRenewal, ContractAsset } from "../assets/asset.type";
import { Company } from "../companies/company.type";
import { MaintenanceProvider } from "../maintenance-provider/maintenance-provider.types";

//#region Interface

export interface Contract extends Entity {
  id?: string;
  name: string;
  type: string;
  status: ContractStatus;
  startDate: string;
  endDate: string;
  notes: string;
  configurationNotes: string;
  number: string;
  company: Company;
  companyId: string;
  maintenanceProviderId: string;
  maintenanceProvider: MaintenanceProvider;
  version: number;
  assets?: Asset[];
  reseller?: string;
  sfOpportunity?: string;
  totalChannelWorksCost?: number;
  totalPartnerPrice?: number;
  totalCompanyPrice?: number;
  numberVersion: string;
  contractAssets: ContractAsset[];
}

export interface ContractAttachment extends Entity {
  id: string;
  name: string;
  url: string;
  description: string;
  contractId: string;
  notes: string;
  contract: Contract;
  file?: File;
  extension?: string;
}

export interface ContractRenewal {
  contractId: string;
  name: string;
  startDate: Date;
  endDate: Date;
  sfOpportunity?: string;
  notes: string;
  configurationNotes: string;
  newAssets: AssetRenewal[];
  renewedAssets: AssetRenewal[];
  maintenanceProviderId?: string;
  maintenanceProvider?: MaintenanceProvider;
}

export interface ContractCountByEndDate {
  late?: number;
  now?: number;
  plus30?: number;
  plus90?: number;
}
//#endregion

//#region Enum
export enum ContractStatus {
  pending = "pending",
  active = "active",
  terminated = "terminated",
  expired = "expired",
}
//#endregion
